import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { store } from "../../src/store/store";
import { parseRequire } from "../../src/utils/parseImageUrl";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { cashier } from "../characters/Cashier";
import { chris } from "../characters/Chris";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { annImages } from "../helpers/annInstaImages";
import { doTransition } from "../helpers/helpers";
import { images } from "./images";
import { start } from "./V1";
import { V5AfterAnnMovie } from "./V5";

export const V5AnnMovie = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);


    await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann5 }, async () => {
        Phone.setMessage({ character: ann.character, text: `${mc.name}?` });
        Phone.setMessage({ character: mc.character, text: `Ann! What's up?` });
        Phone.setMessage({ character: ann.character, text: `Do you have any plans for tonight?` });
        Phone.setMessage({ character: mc.character, text: `No, I'm free.` });
        Phone.setMessage({ character: ann.character, text: `Great!!!` });
        Phone.setMessage({ character: ann.character, text: `There is a premiere of a movie I want to see...` });
        Phone.setMessage({ character: ann.character, text: `All the tickets have been sold out, but I still want to go and see if I'll be lucky enough to get in.` });
        Phone.setMessage({ character: ann.character, text: `Join me?` });
        Phone.setMessage({ character: ann.character, text: `Pleaseeee!` });
        Phone.setMessage({ character: mc.character, text: `Sure, I'll join you.` });
        Phone.setMessage({ character: ann.character, text: `Yay!!!` });
        Phone.setMessage({ character: ann.character, text: `Open the door, hehe.` });
        Phone.closeMessagesUI();
    });



    return jump(V5AnnMovieAgree, "V5AnnMovieAgree");
};

export const V5AnnMovieAgree = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);

    mc.think(`Did she come before I agreed?`);
    ImageClass.setImage(images.v5.AnnArrived_0, { wait: true, hideText: true });
    ImageClass.setImage(images.v5.AnnArrived_1);
    mc.think(`Ann? Wearing these clothes?`);
    mc.talk(`Hey Ann.`);
    mc.talk(`That was fast.`);
    return jump(V5AnnMovieAgree_2, "V5AnnMovieAgree_2");
};
export const V5AnnMovieAgree_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnArrived_1);
    await ann.setQuestion(new Question({ text: `I was already out of the house when we started texting.`, options: { think: false }, key: `v5ComplimentedAnnOutfit` })
        .option({ title: `Compliment on her outfit`, key: true })
        .option({ title: `Don't compliment`, key: false }));


    if (Question.globalAnswers.v5ComplimentedAnnOutfit) {
        return jump(V5AnnMovieAgree_2_1, "V5AnnMovieAgree_2_1");

    } else {
        return jump(V5AnnMovieAgree_2_2, "V5AnnMovieAgree_2_2");

    }

};


export const V5AnnMovieAgree_2_1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnArrived_1);
    mc.talk(`I like what you are wearing, you look hot.`);
    ann.talk(`Oh! Hehe! Thank you.`);
    if (mc.properties.annBarCorruptionConv) {

        ann.talk(`I was always ashamed leaving the house like this.`);
        ann.talk(`But I decided it's another first step in embracing what I want... Right?`);
        mc.talk(`Exactly.`);

    } else {

        ann.talk(`I'm just trying out a new look.`);
    }

    mc.talk(`I like it.`);
    ann.talk(`I am glad!`);

    return jump(V5AnnMovieAgree_2_1_Inside, "V5AnnMovieAgree_2_1_Inside");
};

export const V5AnnMovieAgree_2_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnArrived_1);
    if (mc.properties.annBarCorruptionConv) {
        mc.think(`She wasn't kidding about wanting to change...`);

    } else {
        mc.think(`The "new" Ann keeps surprising me...`);
    }

    return jump(V5AnnMovieAgree_2_1_Inside, "V5AnnMovieAgree_2_1_Inside");
};

export const V5AnnMovieAgree_2_1_Inside = async (): Promise<any> => {
    mc.talk(`Are we all set? Do you want to leave right now?`);
    ann.talk(`Mmm... We have a few minutes... Maybe we can pass the time until we need to leave.`);
    mc.talk(`Of course.\nCome inside.`);
    ImageClass.setImage(images.v5.AnnArrived_2);
    // if (mc.properties.annBarCorruptionConv) {

    // } else {

    // }
    mc.talk(`So... Sudden interest in movies, huh?`);
    ImageClass.setImage(images.v5.AnnArrived_4);
    ann.talk(`Sudden? Who doesn't like movies? Hehe.`);
    ann.talk(`I've always loved movies. Especially watching movies of books I've read.`);
    ImageClass.setImage(images.v5.AnnArrived_3);
    ann.talk(`Don't laugh, but I even wanted to become an actress at one point.`);
    mc.talk(`Why would I laugh?`);
    ImageClass.setImage(images.v5.AnnArrived_2);
    ann.talk(`I don't know... The handful of people I've told that laughed.`);
    ann.talk(`I think it's because I can barely talk in front of two strangers without stuttering.`);
    ImageClass.setImage(images.v5.AnnArrived_4);
    ann.talk(`But!`);
    ann.talk(`I have decided to give it a try!`);
    ImageClass.setImage(images.v5.AnnArrived_2);
    mc.talk(`Wow, that's a bit extreme isn't it?`);
    ann.talk(`I can just try it... No commitment... I'm still young.`);
    ImageClass.setImage(images.v5.AnnArrived_4);
    ann.talk(`And I can always continue with my studies if I don't like it or it doesn't pan out.`);

    // mc.talk(`You still haven't told me what's the sudden interest in movies.`);
    // ImageClass.setImage(images.v5.AnnArrived_3);
    // ann.talk(`About that...`);
    // ann.talk(`I was thinking lately about what I want to do in life...`);
    // ImageClass.setImage(images.v5.AnnArrived_2);
    // ann.talk(`You know... About college, career and all of that...`);
    // ann.talk(`Until a few days ago, I thought I wanted to be a doctor.`);
    // ann.talk(`I figured I'll start with being a nurse and move up the ladder...`);

    // mc.talk(`That sounds like a plan.`);
    // ImageClass.setImage(images.v5.AnnArrived_3);

    // ann.talk(`Well... I decided that's too boring for me.`);
    // ImageClass.setImage(images.v5.AnnArrived_2);
    // ann.talk(`I've changed my mind. I don't want to study that anymore.`);
    // mc.talk(`So what do you want to do?`);
    // ImageClass.setImage(images.v5.AnnArrived_4);
    // ann.talk(`I thought about becoming an actress.`);

    ImageClass.setImage(images.v5.AnnArrived_2);
    mc.talk(`Well that sounds like a plan.`);
    // mc.talk(`Wow, you really went with a different thing entirely.`);
    // ann.talk(`Hehe, I know, but that's what I want to do now.`);
    // mc.talk(`What made you change your mind?`);
    // ann.talk(`I don't know exactly.`);

    mc.talk(`I must say, those are two completely different careers.`);
    ann.talk(`I know, but when I'm thinking about being a doctor, I think about the long work hours, the stress and pressure...`);
    // ann.talk(`I was thinking about the long work hours, the stress and pressure...`);
    mc.talk(`It's not that far off from acting.`);
    ann.talk(`Right, but it's different... I think.`);
    ImageClass.setImage(images.v5.AnnArrived_4);
    ann.talk(`And maybe I'll work with famous people!`);
    ImageClass.setImage(images.v5.AnnArrived_2);
    ann.talk(`But I don't want to get ahead of myself... I don't even know where to start.`);

    // mc.talk(`What about all the time you invested already? You spent a lot of time studying already.\nWas that for nothing?`);
    // ann.talk(`That's what made me come to a conclusion it's boring... For me at least.`);
    ImageClass.setImage(images.v5.AnnArrived_4);
    ann.talk(`That's why I want to go to the premier today...`);
    ann.talk(`I figured that if I start going to these kinds of events, I'll meet the right people.`);
    mc.talk(`Well I'll support you either way.`);
    mc.think(`Though seems a bit too optimistic to me...`);
    ann.talk(`But as I said, there is still time before it starts...`);
    // ann.talk(`And I have a good idea of how to pass the time...`);
    ann.talk(`I was thinking...`);
    ann.talk(`Can you do what you did yesterday?`);

    mc.talk(`We did a lot of things, what do you mean exactly?`);
    ImageClass.setImage(images.v5.AnnArrived_5);
    ann.talk(`Come closer and I'll tell you.`);
    // ImageClass.setImage(images.v5.AnnArrived_7);
    ImageClass.setImage(images.v5.AnnArrived_6);
    ann.talk(`This...`);

    return jump(V5AnnMovieAgree_2_1_Inside_Question, "V5AnnMovieAgree_2_1_Inside_Question");
};

export const V5AnnMovieAgree_2_1_Inside_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnArrived_8);
    ann.talk(`Please...`);
    await mc.setQuestion(new Question({ text: `She doesn't know that Emily is in the other room...`, options: { think: true }, key: `v5TouchedAnnInLivingRoom` })
        .option({ title: `Touch her`, key: true })
        .option({ title: `Say you are not alone`, key: false }));


    if (Question.globalAnswers.v5TouchedAnnInLivingRoom) {

        return jump(V5AnnMovieAgree_2_1_Inside_Touch, "V5AnnMovieAgree_2_1_Inside_Touch");
    } else {

        return jump(V5AnnMovieAgree_2_1_Inside_DontTouch, "V5AnnMovieAgree_2_1_Inside_DontTouch");
    }
};


export const V5AnnMovieAgree_2_1_Inside_Touch = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.annRelationship++;
    });
    mc.talk(`You don't have to tell me twice.`);
    ImageClass.setImage(images.v5.AnnArrived_8);
    ann.talk(`Oh...`);
    ImageClass.setImage(images.v5.AnnArrived_7);
    ann.talk(`I think I'm addicted to your touch.`);
    ImageClass.setImage(images.v5.AnnArrived_9);
    ann.talk(`Ahh....`);
    ann.talk(`Oh my God ${mc.name}.`);
    ann.talk(`Faster please.`);
    ImageClass.setImage(images.v5.AnnArrived_10, { duration: 1 });
    mc.think(`She is already dripping wet.`);
    ann.talk(`Yes...`);
    ann.talk(`YES!!`);
    ann.talk(`OH MY GOD!`);
    return jump(V5AnnMovieAgree_2_1_Inside_Touch_2, "V5AnnMovieAgree_2_1_Inside_Touch_2");
};

export const V5AnnMovieAgree_2_1_Inside_Touch_2 = async (): Promise<any> => {
    if (mc.properties.joeStatus === "enemy") {
        ImageClass.setImage(images.v5.AnnArrived_11);

    } else {

        ImageClass.setImage(images.v5.AnnArrived_Outfit_11);
    }

    emily.talk(`${mc.name}? Is everything ok? I heard screa...`);

    if (mc.properties.joeStatus === "enemy") {

        ImageClass.setImage(images.v5.AnnArrived_12);
    } else {

        ImageClass.setImage(images.v5.AnnArrived_Outfit_12);
    }
    emily.talk(`OH... Haha sorry!`);
    mc.think(`I figured that might happen.`);
    ImageClass.setImage(images.v5.AnnArrived_13);
    ann.talk(`Oh my... Who's that?`);
    mc.talk(`That's my ${emily.properties.relation}.`);
    ann.talk(`I haven't seen her before...`);
    mc.talk(`Because she had left home a couple of years ago and came back just today...`);
    ann.talk(`You should've warned me...`);
    ImageClass.setImage(images.v5.AnnArrived_3);
    ann.talk(`I can only imagine what she must be thinking about me now... So much for first impression...`);
    mc.talk(`Relax... She's not like that at all. I'm sure she will like you once she gets to know you.`);
    mc.talk(`And you are my girlfriend... You aren't some random girl I met on the street.`);
    ImageClass.setImage(images.v5.AnnArrived_4);
    ann.talk(`Hehe, yes, that's true...`);
    ann.talk(`So much for passing the time...`);

    mc.talk(`Do you want to go to my room?`);
    ImageClass.setImage(images.v5.AnnArrived_2);
    ann.talk(`No...`);
    ann.talk(`Let's just go right now...`);
    ann.talk(`It's quite a walk on foot anyway.`);
    mc.talk(`Okay, let's go.`);

    return jump(V5AnnMovieArriving, "V5AnnMovieArriving");
};
export const V5AnnMovieAgree_2_1_Inside_DontTouch = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnArrived_7);
    await mc.set((properties) => {
        properties.annRelationship--;
    });
    mc.talk(`We are not alone.`);
    ImageClass.setImage(images.v5.AnnArrived_13);
    ann.talk(`What? Who else is here?`);
    mc.talk(`My ${emily.properties.relation}.`);
    ImageClass.setImage(images.v5.AnnArrived_2);
    ann.talk(`I didn't know you have a ${emily.properties.relation}...`);
    mc.talk(`Yeah... I didn't mention her.`);
    mc.talk(`She hasn't been living here for a couple of years, but she just came back today.`);
    ann.talk(`Why did she come back?`);
    if (mc.properties.joeStatus === "enemy") {
        mc.talk(`I don't know exactly, but she told me she broke up with her boyfriend, so that's might be the reason. But I'm still figuring it out.`);
        ImageClass.setImage(images.v5.AnnArrived_4);
        ann.talk(`Oh... That's a good reason.`);
        ImageClass.setImage(images.v5.AnnArrived_14);


    } else {
        mc.talk(`I don't know yet. I haven't had a chance to talk to her yet.`);
        ImageClass.setImage(images.v5.AnnArrived_4);
        ann.talk(`Oh... ok.`);
        ImageClass.setImage(images.v5.AnnArrived_Outfit_14);

    }
    emily.talk(`${mc.name}, I'm tired. I think I'm going to rest--`);
    emily.talk(`Oh, sorry I didn't know you have company.`);
    mc.talk(`Emily, this is Ann.`);
    emily.talk(`Hey!`);
    ann.talk(`Hi.`);
    if (mc.properties.joeStatus === "enemy") {

        ImageClass.setImage(images.v5.AnnArrived_15);
    } else {

        ImageClass.setImage(images.v5.AnnArrived_Outfit_15);
    }
    emily.talk(`Don't let me disturb you. Talk to you later. Nice meeting you Ann.`);

    ImageClass.setImage(images.v5.AnnArrived_2);
    ann.talk(`Wow, she is really gorgeous.`);
    if (mc.properties.joeStatus === "enemy") {
        ann.talk(`Does she always walk around the house in a bikini?`);
        mc.talk(`Haha, no. We just got back from the beach, and she didn't have time to change.`);
        ann.talk(`Oh, ok.`);
    } else {
        ann.talk(`Good thing that you told me she was here...\nThings could have gotten really embarrassing otherwise.`);
        mc.talk(`Yeah...`);
    }
    ann.talk(`Let's just head to the theater.`);
    mc.talk(`Didn't you say we have time?`);
    ann.talk(`It's quite a walk... We will get there just in time, I think.`);

    mc.talk(`Sounds good, let's go.`);



    return jump(V5AnnMovieArriving, "V5AnnMovieArriving");
};
export const V5AnnMovieArriving = async (): Promise<any> => {
    doTransition(images.v5.AnnMovie_2);


    ann.talk(`That was a long walk, but we are almost there!`);
    ImageClass.setImage(images.v5.AnnMovie_0);
    mc.talk(`I didn't realize it was that far away.`);
    ImageClass.setImage(images.v5.AnnMovie_1);
    ann.talk(`Look! Just in time!`);
    ann.talk(`Come on, let's get a closer look.`);

    ImageClass.setImage(images.v5.AnnMovie_8, { transition: true });
    ann.talk(`They really went all out didn't they? It looks great!`);

    ann.talk(`Wait, is that...?!`);
    ImageClass.setImage(images.v5.AnnMovie_10);
    ann.talk(`Hey! That's Alex! I didn't know she would be here.`);
    ImageClass.setImage(images.v5.AnnMovie_9);
    ann.talk(`Let's go and say hi!`);

    return jump(V5AnnMovieArrivingAlex, "V5AnnMovieArrivingAlex");
};

export const V5AnnMovieArrivingAlex = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_3);
    ann.talk(`Alex!!!`);
    ann.talk(`Hello!!!`);
    ImageClass.setImage(images.v5.AnnMovie_4);
    alex.talk(`BESTIE?`);
    await mc.set((properties) => {
        properties.alexKnowsMC = true;
    });
    alex.talk(`I'm so happy to see you!`);
    alex.talk(`You look HOT!`);
    ann.talk(`Hehe, stop it, I'm not! Especially not when I'm standing next to you.`);
    alex.talk(`You are too!`);
    ImageClass.setImage(images.v5.AnnMovie_5);
    alex.talk(`I've missed you!`);
    ImageClass.setImage(images.v5.AnnMovie_6_eyesClosed);
    ann.talk(`You saw me a few days ago.`);
    ImageClass.setImage(images.v5.AnnMovie_6);

    alex.talk(`Oh.`);
    alex.talk(`Hi there.`);
    mc.talk(`Hey.`);


    return jump(V5AnnMovieArrivingAlex_Question, "V5AnnMovieArrivingAlex_Question");
};
export const V5AnnMovieArrivingAlex_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_7);
    await alex.setQuestion(new Question({ text: `Who are you?`, options: { think: false }, key: `v5ToldAlexYouAreAnsBF` })
        .option({ title: `Ann's boyfriend`, key: true })
        .option({ title: `I'm ${mc.name}`, key: false }));


    if (Question.globalAnswers.v5ToldAlexYouAreAnsBF) {
        return jump(V5AnnMovieArrivingAlex_BF, "V5AnnMovieArrivingAlex_BF");

    } else {
        return jump(V5AnnMovieArrivingAlex_Name, "V5AnnMovieArrivingAlex_Name");

    }
};


export const V5AnnMovieArrivingAlex_BF = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_7);
    mc.talk(`Ann's boyfriend.`);
    alex.talk(`${mc.name}?`);
    mc.talk(`Yes.`);
    alex.talk(`I've heard about you!`);
    ImageClass.setImage(images.v5.AnnMovie_12);
    alex.talk(`But I didn't know you are officially dating!`);
    alex.talk(`Why didn't you tell me?`);
    ann.talk(`I didn't have the chance to update you.`);
    alex.talk(`We have to fix that!`);
    ann.talk(`Of course.`);


    return jump(V5AnnMovieArrivingAlex2, "V5AnnMovieArrivingAlex2");
};


export const V5AnnMovieArrivingAlex_Name = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_7);
    mc.talk(`${mc.name}.`);
    alex.talk(`OH! I heard your name before.`);
    ImageClass.setImage(images.v5.AnnMovie_12);
    ann.talk(`Hey, no need to tell him everything!`);
    ImageClass.setImage(images.v5.AnnMovie_11);
    alex.talk(`Ann talks about you. A LOT!`);
    ImageClass.setImage(images.v5.AnnMovie_12);
    ann.talk(`STOP IT!`);
    alex.talk(`Haha.`);

    return jump(V5AnnMovieArrivingAlex2, "V5AnnMovieArrivingAlex2");
};
export const V5AnnMovieArrivingAlex2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_12);
    ann.talk(`What are you doing here exactly?`);
    alex.talk(`I got an offer over Insta to come and stand here.`);
    alex.talk(`I have no idea why, I should be modeling for guys, but I have only seen girls so far...`);

    ann.talk(`Isn't it boring?`);
    alex.talk(`The guy who contacted me is paying really well, so I'm basically scamming him.`);


    ann.talk(`Speaking of Insta, did you know that ${mc.name} knows you from there?`);
    alex.talk(`I didn't!`);

    return jump(V5AnnMovieArrivingAlex2_Question, "V5AnnMovieArrivingAlex2_Question");
};
export const V5AnnMovieArrivingAlex2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_11);
    await alex.setQuestion(new Question({ text: `What's your Insta name?`, options: { think: false }, key: `v5ToldRealInstaUserName` })
        .option({ title: `Tell the truth`, key: true })
        .option({ title: `Make something up`, key: false }));


    if (Question.globalAnswers.v5ToldRealInstaUserName) {
        return jump(V5AnnMovieArrivingAlex2_Truth, "V5AnnMovieArrivingAlex2_Truth");

    } else {

        return jump(V5AnnMovieArrivingAlex2_Lie, "V5AnnMovieArrivingAlex2_Lie");
    }

};


export const V5AnnMovieArrivingAlex2_Truth = async (): Promise<any> => {
    const mcUser = store?.getState().insta.present.userName;
    ImageClass.setImage(images.v5.AnnMovie_11);
    mc.talk(`My user is: ${mcUser}.`);
    if (Game.seenScenarios.includes(`V3ShowAlexEasterEgg1`)) {
        alex.talk(`Wait...`);
        alex.talk(`I know that name.`);
        alex.talk(`I sent you a private image of mine!`);
        ImageClass.setImage(images.v5.AnnMovie_12);
        ann.talk(`What image?`);
        alex.talk(`The one I showed you. In the tanning bed.`);
        ann.talk(`Oh... Why?`);
        alex.talk(`He asked for it so I sent it.`);
        if (alex.properties.mcWroteLoveU) {
            alex.talk(`He is so cute, he even told me he loves me.`);
            ann.talk(`Really...?`);
            ImageClass.setImage(images.v5.AnnMovie_11);
            ann.talk(`${mc.name}?`);
            alex.talk(`I'm sure he was just joking, he doesn't even know me.`);
            if (mc.properties.alpha > 5) {

                mc.talk(`Chill, I was just curious about the picture.`);
            } else {

                mc.talk(`It was a joke.`);
            }
            ann.talk(`Oh, ok.`);
        } else {

        }
    } else {
        alex.talk(`Sorry but I don't remember that one.`);
        mc.talk(`That's ok.`);
    }

    return jump(V5AnnMovieArrivingAlex3, "V5AnnMovieArrivingAlex3");
};


export const V5AnnMovieArrivingAlex2_Lie = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_11);
    mc.talk(`My username is: Someone123.`);
    alex.talk(`I don't think that I've seen that nickname...`);
    return jump(V5AnnMovieArrivingAlex3, "V5AnnMovieArrivingAlex3");
};

export const V5AnnMovieArrivingAlex3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_12);
    alex.talk(`Ok, I need to get back to work.`);
    ImageClass.setImage(images.v5.AnnMovie_6_eyesClosed);
    alex.talk(`Call me tomorrow! We should hang out more.`);
    ImageClass.setImage(images.v5.AnnMovie_5);
    ann.talk(`I will.`);
    alex.talk(`LOVE THE OUTFIT!`);
    ann.talk(`Hehe.`);
    ImageClass.setImage(images.v5.AnnMovie_13, { transition: true });

    ann.talk(`That was a nice surprise!`);

    return jump(V5AnnMovieArrivingAlex3_Question, "V5AnnMovieArrivingAlex3_Question");
};

export const V5AnnMovieArrivingAlex3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_13);
    await ann.setQuestion(new Question({ text: `What do you think about her?`, options: { think: false }, key: `v5ToldAnnAlexIsHot` })
        .option({ title: `She is hot`, key: true })
        .option({ title: `She is nice`, key: false }));


    if (Question.globalAnswers.v5ToldAnnAlexIsHot) {

        return jump(V5AnnMovieArrivingAlex3_Hot, "V5AnnMovieArrivingAlex3_Hot");
    } else {

        return jump(V5AnnMovieArrivingAlex3_Nice, "V5AnnMovieArrivingAlex3_Nice");
    }
};


export const V5AnnMovieArrivingAlex3_Hot = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_13);
    await mc.set((properties) => {
        properties.alpha++;
    });
    mc.talk(`She is hot.`);
    ImageClass.setImage(images.v5.AnnMovie_13_2);
    ann.talk(`I meant about her personality but yes... She is hot, I know.`);
    mc.talk(`I can't overlook it.`);
    ann.talk(`I know...`);
    ann.talk(`Let's see if we can get tickets...`);
    return jump(V5AnnMovieStandingInLine, "V5AnnMovieStandingInLine");
};


export const V5AnnMovieArrivingAlex3_Nice = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_13);
    mc.talk(`She is nice.`);
    ann.talk(`I know! I love her.`);
    mc.think(`Me too...`);
    ann.talk(`I'm glad you like her.`);
    ann.talk(`Now, let's see if we will be lucky enough to get tickets.`);
    return jump(V5AnnMovieStandingInLine, "V5AnnMovieStandingInLine");
};
export const V5AnnMovieStandingInLine = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_14, { transition: true });
    ann.talk(`Hey!`);
    ann.talk(`I would like to buy two tickets for ...`);
    cashier.talk(`We are all sold out.`);
    ann.talk(`You didn't ask which movie...`);
    cashier.talk(`Fifthly Greys of Sasha?`);
    ann.talk(`Yes... That's the one.`);
    cashier.talk(`We are all sold out.`);
    ann.talk(`Please, isn't there anything you can do? I really want to see the movie.`);
    ImageClass.setImage(images.v5.AnnMovie_15);
    cashier.talk(`I'm not a magician. There aren't any tickets left; you should have ordered beforehand.`);
    ann.talk(`I know, but I came early so maybe I could b...`);
    cashier.talk(`Is there anything else I can help you with?`);
    ann.talk(`Ahh... Are there tickets for tomorrow?`);
    cashier.talk(`No, try again next month, maybe you will get lucky then.`);
    ann.talk(`Next month? Are you serious? How about next week?`);
    return jump(V5AnnMovieStandingInLine_Question, "V5AnnMovieStandingInLine_Question");
};


export const V5AnnMovieStandingInLine_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_15);
    await cashier.setQuestion(new Question({ text: `Full.\nIs there anything ELSE I can help you with?`, options: { think: false }, key: `v5GotMadAtTheCashier` })
        .option({ title: `Get angry at the cashier`, key: true })
        .option({ title: `Let it be`, key: false }));


    if (Question.globalAnswers.v5GotMadAtTheCashier) {

        return jump(V5AnnMovieStandingInLine_Angry, "V5AnnMovieStandingInLine_Angry");
    } else {

        return jump(V5AnnMovieStandingInLine_LetItBe, "V5AnnMovieStandingInLine_LetItBe");
    }

};

export const V5AnnMovieStandingInLine_Angry = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.alpha += 2;
    });
    ImageClass.setImage(images.v5.AnnMovie_15);
    mc.talk(`What the fuck is wrong with you?`);
    ImageClass.setImage(images.v5.AnnMovie_16);
    cashier.talk(`I told her like three times that there aren't any tickets left.`);
    mc.talk(`I don't care if there are or aren't any tickets left, but as long as we are standing here, you are working for us, so fix your fucking attitude.`);
    cashier.talk(`Whatever...`);
    return jump(V5AnnMovieStandingInLine_2, "V5AnnMovieStandingInLine_2");
};

export const V5AnnMovieStandingInLine_LetItBe = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_15);
    await mc.set((properties) => {
        properties.alpha -= 2;
    });
    ann.talk(`No... Thank you.`);
    return jump(V5AnnMovieStandingInLine_2, "V5AnnMovieStandingInLine_2");
};

export const V5AnnMovieStandingInLine_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_17);
    ann.talk(`I knew it's a lost cause...`);
    ann.talk(`Let's just leave.`);
    mc.talk(`Are you sure?`);
    ann.talk(`Yes... I'll just wait till they have tickets.`);
    return jump(V5AnnMovieEnd, "V5AnnMovieEnd");
};

export const V5AnnMovieEnd = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMovie_17);
    mc.talk(`Is there another theater we can try?`);
    ann.talk(`Unfortunately no...`);
    mc.talk(`Let's go to my place.`);
    ann.talk(`I'm sorry, but I can't today.`);
    mc.talk(`Alright.\nI'll walk you home.`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

        return jump(V5AnnMovieEndChris, "V5AnnMovieEndChris");
    }
    return jump(V5AnnMovieEndAlone, "V5AnnMovieEndAlone");
};

export const V5AnnMovieEndChris = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_0, { transition: true });
    mc.think(`She looks extremely disappointed.`);
    mc.think(`Getting inside was really important to her.`);
    ImageClass.setImage(images.v5.AnnChrisHome_1);
    mc.talk(`Ann. Cheer up, you will see the movie eventually.`);
    ann.talk(`I know... But it's hard for me to hide my feelings.`);
    ImageClass.setImage(images.v5.AnnChrisHome_2);
    ann.talk(`I know it may seem immature to you... But that's just how I am.`);
    ImageClass.setImage(images.v5.AnnChrisHome_3);
    chris.talk(`Hey beautiful!`);
    mc.think(`What is he doing here?`);
    ann.talk(`Chris! Hey!`);
    if (Question.globalAnswers.v4NoJoeyWasMeanToChris === false) {

        return jump(V5AnnMovieEndChrisNice, "V5AnnMovieEndChrisNice");
    }
    return jump(V5AnnMovieEndChrisMean, "V5AnnMovieEndChrisMean");


};


export const V5AnnMovieEndChrisNice = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_4);
    chris.talk(`Yo ${mc.name}! What's up?`);
    mc.talk(`I'm fine.`);
    chris.talk(`Good to see you bro.`);


    return jump(V5AnnMovieEndChris_2, "V5AnnMovieEndChris_2");
};


export const V5AnnMovieEndChrisMean = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_3);
    chris.talk(`What are you doing here?`);
    ann.talk(`I came with ${mc.name} to see Fifthly Greys of Sasha...`);
    ImageClass.setImage(images.v5.AnnChrisHome_4);
    chris.talk(`Oh. Hi. Didn't see you.`);
    mc.think(`Yeah right...`);

    return jump(V5AnnMovieEndChris_2, "V5AnnMovieEndChris_2");
};


export const V5AnnMovieEndChris_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_5);
    chris.talk(`So, why aren't you inside?`);
    ann.talk(`They ran out of tickets.`);
    chris.talk(`Makes sense given it's the premiere.`);
    ann.talk(`I know... I figured that if we came early we'd manage to get tickets.`);
    chris.talk(`That's too bad...`);
    chris.talk(`Anyway, do you need a ride home?`);
    ann.talk(`Oh! I would love to, but I didn't come alone.`);

    return jump(V5AnnMovieEndChris_2_Question, "V5AnnMovieEndChris_2_Question");
};

export const V5AnnMovieEndChris_2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_4);
    await ann.setQuestion(new Question({ text: `${mc.name}?`, options: { think: false }, key: `v5AcceptedRideFromChris` })
        .option({ title: `Sure, why not`, key: true })
        .option({ title: `I'd rather walk`, key: false }));


    if (Question.globalAnswers.v5AcceptedRideFromChris) {

        return jump(V5AnnMovieEndChris_2_Sure, "V5AnnMovieEndChris_2_Sure");
    } else {

        return jump(V5AnnMovieEndChris_2_Walk, "V5AnnMovieEndChris_2_Walk");
    }
};

export const V5AnnMovieEndChris_2_Sure = async (): Promise<any> => {
    mc.talk(`Sure, why not.`);
    chris.talk(`Great, get in!`);
    return jump(V5AnnMovieEndChris_3, "V5AnnMovieEndChris_3");
};

export const V5AnnMovieEndChris_2_Walk = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_4);

    mc.talk(`I'd rather walk.`);
    ann.talk(`Please! My legs hurts!`);
    mc.talk(`...`);
    mc.talk(`Fine.`);
    mc.think(`I don't like it, but whatever.`);
    chris.talk(`Great, get in!`);

    return jump(V5AnnMovieEndChris_3, "V5AnnMovieEndChris_3");
};
export const V5AnnMovieEndChris_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnChrisHome_6, { transition: true });
    chris.talk(`So what's your address?`);
    ann.talk(`324 Peaches St.`);
    chris.talk(`Woah, that's far, did you walk all this way on foot?`);
    ann.talk(`Yes, we did.`);
    chris.talk(`The movie must be really important to you.`);
    ann.talk(`It must seem stupid, but it really is.`);

    chris.talk(`What if I told you that I know someone that could get you tickets?`);
    ImageClass.setImage(images.v5.AnnChrisHome_7);
    ann.talk(`What??`);
    ann.talk(`Really??`);
    ann.talk(`How?`);
    mc.think(`Of course he does.`);
    chris.talk(`I know a guy.`);
    ann.talk(`When could I see it?`);

    chris.talk(`If not tomorrow, so in a few days.`);
    ann.talk(`Oh my God! How much will it cost?`);
    chris.talk(`For you? Free.`);
    ann.talk(`Thank you!`);
    ImageClass.setImage(images.v5.AnnChrisHome_8);
    ann.talk(`Can you believe how lucky we are?`);
    chris.talk(`You are.`);
    ImageClass.setImage(images.v5.AnnChrisHome_6);
    ann.talk(`What do you mean?`);
    chris.talk(`I have only two tickets and I want to see it as well.`);
    ann.talk(`Can you get a ticket for ${mc.name} also?`);
    if (Question.globalAnswers.v4NoJoeyWasMeanToChris === false) {

        chris.talk(`I can ask but I'm not promising anything.`);
        ann.talk(`Thank you!`);
    } else {
        chris.talk(`I can't, you saw how hard it is to get a single ticket as it is.`);
        ImageClass.setImage(images.v5.AnnChrisHome_9);
        ann.talk(`Oh...`);
    }

    chris.talk(`Here we are.`);
    ImageClass.setImage(images.v5.AnnChrisHome_10);
    ann.talk(`That was quick.`);
    chris.talk(`It's fast by car.`);
    ann.talk(`Yeah, I guess.`);
    ann.talk(`About the ticket...`);
    chris.talk(`I don't need an answer right now.\nJust tell me soon if you wanna come or not.`);
    ann.talk(`Ok, thank you for driving us.`);
    chris.talk(`Anytime.\nGood night!`);
    return jump(V5AnnMovieEndAlone, "V5AnnMovieEndAlone");
};

export const V5AnnMovieEndAlone = async (): Promise<any> => {
    doTransition(images.v5.AnnAfterMoviesHome_30);
    ann.talk(`Thanks for coming with me.`);
    mc.talk(`Of course.`);
    ImageClass.setImage(images.v5.AnnAfterMoviesHome_32);
    ann.talk(`I hope it wasn't too much trouble for you.`);
    ImageClass.setImage(images.v5.AnnAfterMoviesHome_31);
    mc.talk(`Not at all.`);
    mc.talk(`I hope you are not disappointed.`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_32);
        ann.talk(`I was, but knowing that Chris has a spare ticket cheered me up.`);
        ann.talk(`But I have mixed feelings...`);
        ann.talk(`I don't know if I should go with him... You know... Because of you.`);
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_31);
        mc.talk(`He might be bluffing.`);
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_32);
        ann.talk(`You think? Why would he do that?`);
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_31);
        mc.talk(`It just looks like a convenient coincidence.`);
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_32);
        ann.talk(`I didn't think about that.`);
        ann.talk(`But if you are right, what was he doing there at that time?`);
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_31);
        mc.talk(`I don't know. I guess we'll see.`);
        ann.talk(`Anyway...`);
    } else {
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_31);
        ann.talk(`Just a bit, only because I was really eager to see the movie.`);
        ann.talk(`But it's no biggie, I'll see it eventually.`);
        ImageClass.setImage(images.v5.AnnAfterMoviesHome_33);
        ann.talk(`Anyway...`);
    }

    ImageClass.setImage(images.v5.AnnAfterMoviesHome_33);
    ann.talk(`Good night! I'll talk to you tomorrow.`);
    ann.talk(`Sorry for refusing your invitation.`);
    mc.talk(`That's fine.`);
    ImageClass.setImage(images.v5.AnnAfterMoviesHome_34);
    ann.talk(`Muah!`);


    return jump(V5AfterAnnMovie, "V5AfterAnnMovie");
};
